module.exports = __webpack_public_path__ + "072fd6e76c36297f6f08f953bf3728bb.png";